module.exports = __webpack_public_path__ + "img/img_13@2x.96f0dcf8.png";